import { OrganizationSettings } from '@care-portals/api-interfaces';
import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../data';

export const doc: OrganizationSettings = {
  name: 'Doctor Approved Meds',
  replyToEmail: 'no-reply@doctorapprovedmeds.com',
  ecommerceEnabled: false,
  stripeEnabled: false,
  patientPortalDomain: 'doc.portals.care',
  pharmacyEmail: 'pharmacy@doctorapprovedmeds.com',
  customerServiceEmail: 'help@doctorapprovedmeds.com',
  noMarketingListId: '',
  bigcommerceCustomerGroupId: 0,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  adminCustomDomain: 'emr.portals.care',
  currency: 'usd',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By clicking on {{cta_label}} you agree to our:<br />
    <a
      href="javascript:window.open('https://doctorapprovedmeds.com/privacy-policy', 'popup', 'width=600,height=600');"
    >
        Privacy Policies
    </a>
    <br>
    <a
      href="javascript:window.open('https://doctorapprovedmeds.com/terms-conditions', 'popup', 'width=600,height=600');"
    >
    Terms & Conditions
    </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'Doc Approved Meds',
    icon: '',
    logo: 'https://doctorapprovedmeds.com/wp-content/uploads/2024/07/Logo200x60.jpg',
    locations: [...usStates.map(s => ({ label: s.province, value: s.code }))],
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Doc Approved Meds',
    defaultPingMsg:
      '🛎️ Ping! Doctor Approved Meds team is waiting for your response. To respond, please go to https://doc.portals.care/messages',
    questionnaires: [
      'facesheet',
      'facesheet_ext',
      'selfie',
      'govId',
      'bodySelfie',
      'wlus',
      'wlusmonthly'
    ],
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Consultations',
        name: 'consultations',
        link: ADMIN_WEB_PAGES_URLS.consultations.onlineList,
        icon: 'fas fa-user-md',
        roles: ['*']
      },
      {
        title: 'Orders',
        name: 'orders',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['*']
      },
      {
        title: 'Subscriptions',
        name: 'subscriptions',
        link: ADMIN_WEB_PAGES_URLS.subscriptions.allList,
        icon: 'fas fa-bars',
        roles: ['*']
      },
      {
        title: 'Drugs',
        link: ADMIN_WEB_PAGES_URLS.drugs.allList,
        icon: 'fas fa-pills',
        roles: ['*']
      },
      {
        title: 'RXs',
        name: 'rxs',
        link: ADMIN_WEB_PAGES_URLS.prescriptions.allList,
        icon: 'fas fa-prescription',
        roles: ['pharmacy', 'admin', 'owner']
      }
    ]
  },
  patientWebAppLayout: {
    title: 'Doctor Approved Meds',
    brand: 'doc',
    theme: 'doc',
    shopUrl: 'https://doctorsapporvedmeds.com',
    gtm: {
      id: 'GTM-NN3FR4GP'
      //   url: 'https://gtm.doctorapprovedmeds.com/gtm.js'
    },
    topAction: {
      title: 'Shop',
      link: 'https://doctorapprovedmeds.com'
    },
    logo: {
      img: 'https://doctorapprovedmeds.com/wp-content/uploads/2024/07/Logo200x60.jpg',
      link: '/home'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://doc.portals.care/auth/signup',
      referralFAQ: 'https://doc.portals.care/referral-rewards/'
    },
    privacyPolicyUrl: 'https://doc.portals.care/privacy-policy',
    termsOfUseUrl: 'https://doc.portals.care/terms-of-use',
    stripePublicKey:
      'pk_live_51PcpVtRptjqqU86IxURqd7fKrIVW1xjpNtuypAlcVl8mr85FpKIcKYk9Zc7LG2VCycF53QzQTfEJHRectzOGZzCW00dAEKmNjk',
    nmiPublicKey: '6Cy345-r99KkQ-Pk2Qr2-2aSnck',
    availableStates: {
      us: [
        ...usStates.filter(
          s => !['AR', 'CA', 'LA', 'AL', 'MS'].includes(s.code)
        )
      ]
    },
    mainMenu: [
      {
        title: 'Profile',
        link: PATIENT_WEB_PAGES_URLS.account.profile,
        svg: 'assets/icons/profile.svg',
        roles: ['*']
      },
      {
        title: 'Orders',
        link: PATIENT_WEB_PAGES_URLS.account.orders,
        svg: 'assets/icons/orders.svg',
        roles: ['*']
      },
      {
        title: 'Consultations',
        link: PATIENT_WEB_PAGES_URLS.account.consultations,
        svg: 'assets/icons/consultations.svg',
        roles: ['*']
      },
      {
        title: 'Prescriptions',
        link: PATIENT_WEB_PAGES_URLS.account.prescriptions,
        svg: 'assets/icons/rxs.svg',
        roles: ['*']
      },
      {
        title: 'Medical Inbox',
        link: PATIENT_WEB_PAGES_URLS.messages.inbox,
        svg: 'assets/icons/medical-chat.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: PATIENT_WEB_PAGES_URLS.account.billing,
        svg: 'assets/icons/billing.svg',
        roles: ['*']
      },
      {
        title: 'Shop',
        link: 'shop',
        svg: 'assets/icons/shop.svg',
        type: 'external',
        roles: ['*']
      }
    ]
  },
  pharmacies: {
    Foothills: {
      _id: '66ab2728d1f4e892b4d206dc',
      belugaId: '1978',
      states: ['IN', 'MN', 'NE', 'TX', 'NC']
    },
    Promise: {
      _id: '66ab275ad1f4e892b4d206e1',
      belugaId: '8453',
      states: [
        'AK',
        'AZ',
        'CO',
        'CT',
        'DE',
        'FL',
        'GA',
        'HI',
        'ID',
        'IL',
        'IA',
        'KS',
        'KY',
        'ME',
        'MD',
        'MA',
        'MI',
        'MO',
        'MT',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TN',
        'UT',
        'VT',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY'
      ]
    }
  }
};
